import React from "react";
import ReactDOM from "react-dom/client";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import Layout from "./Constant/Layout";
import Home from "./Components/Home/Home";
import AboutUs from "./Components/AboutUs/AboutUs";
import Careers from "./Components/Careers/Careers";
import ProductDetail from "./Components/ProductDetail/ProductDetail";
import ContactUs from "./Components/ContactUs/ContactUs";
AOS.init();

const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" element={<Layout />}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      {/* <Route path="wireProducts" element={<WireProducts />} /> */}
      <Route path="/ProductDetail/:id" element={<ProductDetail />} />
      {/* <Route path="steelProducts" element={<SteelProduct />} /> */}
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact-us" element={<ContactUs />} />
    </Route>
  )
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={routes} />
);
